<template>
    <svg
        fill="none"
        height="18"
        viewBox="0 0 16 18"
        width="16"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1147_2019)">
            <path
                d="M12.5 6.74219H11.3738V4.01189C11.3738 2.07542 9.85981 0.5 7.99884 0.5C6.13787 0.5 4.62384 2.07542 4.62384 4.01189V6.74219H3.5C2.46613 6.74219 1.625 7.63588 1.625 8.73438V15.5078C1.625 16.6063 2.46613 17.5 3.5 17.5H12.5C13.5339 17.5 14.375 16.6063 14.375 15.5078V8.73438C14.375 7.63588 13.5339 6.74219 12.5 6.74219ZM5.87384 4.01189C5.87384 2.80775 6.82712 1.82812 7.99884 1.82812C9.17056 1.82812 10.1238 2.80775 10.1238 4.01189V6.74219H5.87384V4.01189ZM13.125 15.5078C13.125 15.874 12.8446 16.1719 12.5 16.1719H3.5C3.15538 16.1719 2.875 15.874 2.875 15.5078V8.73438C2.875 8.36821 3.15538 8.07031 3.5 8.07031H12.5C12.8446 8.07031 13.125 8.36821 13.125 8.73438V15.5078Z"
                fill="currentColor" />
            <path
                d="M8 9.99609C7.36141 9.99609 6.84375 10.5461 6.84375 11.2246C6.84375 11.6578 7.055 12.0384 7.37384 12.2572V13.7148C7.37384 14.0816 7.65366 14.3789 7.99884 14.3789C8.344 14.3789 8.62384 14.0816 8.62384 13.7148V12.2587C8.94397 12.0402 9.15625 11.6589 9.15625 11.2246C9.15625 10.5461 8.63859 9.99609 8 9.99609Z"
                fill="currentColor" />
        </g>
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
